import { createContext } from 'react';
import type { CreateStore } from './createStore';

export type StoreProviderContextType = CreateStore<{ (): any; <U>(selector: (state: any) => U, equals?: ((a: U, b: U) => boolean) | undefined): U; }>;
export const StoreProviderContext = createContext<StoreProviderContextType>({} as StoreProviderContextType);
